/** Splits items into consecutive batches of at most batchSize. */
export function chunkArray<T>(items: T[], batchSize: number): T[][] {
  const batchCount = Math.ceil(items.length / batchSize);
  return Array.from({ length: batchCount }, (_, index) =>
    items.slice(index * batchSize, (index + 1) * batchSize),
  );
}
